import React, { createContext, useState, useContext, useEffect } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import {getTheme, updateColors} from './theme';
const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);
const defaultTheme = 'light';
const getInitialTheme = () => {
    return getTheme(localStorage.getItem('theme') === 'dark' ? 'dark' : defaultTheme)
}

window.openkbsTheme = getInitialTheme();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(getInitialTheme);

    const toggleTheme = () => {
        setTheme((prevTheme) => {
            const newMode = prevTheme.palette.mode === 'light' ? 'dark' : 'light';
            localStorage.setItem('theme', newMode);
            // updateColors(newMode)
            // return getTheme(newMode);
            return prevTheme
        });
        window.location.reload();
    };

    useEffect(() => {
        updateColors(theme.palette.mode);
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            <MuiThemeProvider theme={createTheme(theme)}>
                {children}
            </MuiThemeProvider>
        </ThemeContext.Provider>
    );
};